var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4165 7.33398C18.9353 7.33398 20.1665 6.10277 20.1665 4.58398C20.1665 3.0652 18.9353 1.83398 17.4165 1.83398C15.8977 1.83398 14.6665 3.0652 14.6665 4.58398C14.6665 6.10277 15.8977 7.33398 17.4165 7.33398Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 11.916H10.9998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 15.584H14.6665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 1.83398H8.25016C3.66683 1.83398 1.8335 3.66732 1.8335 8.25065V13.7507C1.8335 18.334 3.66683 20.1673 8.25016 20.1673H13.7502C18.3335 20.1673 20.1668 18.334 20.1668 13.7507V9.16732",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectStatus);
export default __webpack_public_path__ + "static/media/project-status.b8691cdb852e4adf0a74f0e0a13cc06f.svg";
export { ForwardRef as ReactComponent };